import { useCachedApi } from '@/lib/hooks/use-cached-api';
import { horodatyApi } from '@/lib/utils/horodaty-api';

/**
 * Hook pour récupérer la liste des templates de procédures
 *
 * @returns {{
 *   templates: Array<{
 *     uniq_id: string,
 *     name: string,
 *     description?: string,
 *     color: string,
 *     configuration: object,
 *     share_subsidiaries: boolean,
 *     creator: { company?: string, user?: string },
 *     created_at: string,
 *     updated_at: string
 *   }>,
 *   isLoading: boolean,
 *   error: Error | null,
 *   refetch: (force?: boolean) => Promise<void>,
 *   invalidate: () => void
 * }}
 */
export function useProcedureTemplates() {
    const {
        data: templates,
        isLoading,
        error,
        refetch,
        invalidate,
    } = useCachedApi(
        'procedure-templates',
        async () => {
            console.log('[useProcedureTemplates] Fetching templates...');
            try {
                const response = await horodatyApi.procedureTemplates.list();
                console.log('[useProcedureTemplates] Response:', {
                    status: response.status,
                    data: response.data,
                });
                // Format: { success: true, data: { templates: [...] } }
                const templates = response.data?.data?.templates || response.data?.templates || [];
                return templates;
            } catch (err) {
                console.error('[useProcedureTemplates] Error:', {
                    message: err.message,
                    status: err.response?.status,
                    data: err.response?.data,
                });
                throw err;
            }
        },
        {
            category: 'procedures',
            initialData: [],
        },
    );

    return {
        templates: templates || [],
        isLoading,
        error,
        refetch,
        invalidate,
    };
}
